<template>
    <div class="question-column-wrapper">
        <div
            class="user-question-data"
            :class="{ 'show-hidden': showHideStyle, 'single-text': !showHideStyle }"
            ref="standText"
            @mousemove="moveHandle"
            @mouseout="outHandle"
        >
            <span class="text">
                <span class="translate" v-show="row.addData.questionLang" @click.stop="showEnClick">{{ this.row.addData.questionLang.toUpperCase() }}</span>
                <el-link v-if="isCurrentGame" @click="jumpQuestionEdit">{{ data }}</el-link>
                <span v-else>{{ data }}</span>
            </span>
        </div>
        <div class="hover-cls" v-show="showDetail && showHideStyle && !isShowEn && data">{{ data }}</div>
        <div class="hover-cls" v-show="isShowEn">{{ row.addData.enStandQuestion }}</div>
    </div>
</template>

<script>
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal";

export default {
    name: "StandQuestionColumn",
    props: ["data", "row"],
    data() {
        return {
            showDetail: false,
            lineHight: "",
            isShowEn: false
        };
    },
    computed: {
        showHideStyle() {
            if (this.lineHight > 48) {
                return true;
            } else {
                return false;
            }
        },
        isEn() {
            return this.row.addData.answerLang !== "en" ? true : false;
        },
        isCurrentGame() {
            const { gameId } = this.row.addData;
            const currentGameId = this.$store.state.zhiji.gameState.gameId;
            if (gameId == currentGameId) {
                return true;
            } else {
                return false;
            };
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.lineHight = this.$refs.standText.scrollHeight;
        });
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
    methods: {
        windowClick(event) {
            if (!this.$el.contains(event.target)) {
                this.isShowEn = false;
            }
        },
        moveHandle() {
            this.showDetail = true;
        },
        outHandle() {
            this.showDetail = false;
        },
        showEnClick() {
            this.isShowEn = !this.isShowEn;
        },
        jumpQuestionEdit() {
            // 跳到问题编辑
            this.$store.dispatch("zhiji/showModal", {
                type: QuestionEditModal,
                data: {
                    questionId: this.row.questionId,
                    sceneId: this.row.addData.sceneId,
                    curPanel: "AnswerPanel",  
                    closeHandler: () => {}
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.question-column-wrapper {
    position: relative;

    .user-question-data {
        padding-right: 8px;
        word-break: break-all;
        word-wrap: break-word;
        overflow: hidden;
        height: 34px;
        line-height: 17px;
        align-items: center;
        .text {
            max-height: 34px;
        }
    }

    .single-text {
        display: flex;
    }

    .show-hidden {
        &:after {
            content: "...";
            width: 11px;
            position: absolute;
            top: 14px;
            right: 2px;
        }
    }

    .hover-cls {
        position: absolute;
        background: #fff;
        border-radius: 4px;
        padding: 5px 8px;
        top: auto;
        margin-top: 8px;
        width: 200%;
        text-align: center;
        white-space: normal;
        word-break: break-all;
        word-wrap: break-word;
        text-align: left;
        box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
        z-index: 1;
    }

    .translate {
        line-height: 14px;
        height: 14px;
        min-width: 26px;
        padding: 0 4px;
        box-sizing: border-box;
        text-align: center;
        background: #2ec2ff;
        color: #fff;
        border-radius: 7px;
        margin-right: 4px;
        cursor: pointer;
        white-space: nowrap;
    }
}
</style>
